module.exports = __webpack_public_path__ + "static/media/slebrity-auction.11d94003.png";